import React,{useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {Card,PageTitle,Status} from '../components/Shared';
import {appendLog,buildSessions,rescheduleSessionDeliveries} from '../storage';

const blank={
  name:'',description:'',date:'',speaker:'',url:'',bonus:'',status:'下書き',
  capacity:100,recurrence:'single',occurrenceCount:4,reminders:true
};

function WebinarForm({initial,onSave,onClose,isExisting}) {
  const [form,setForm]=useState({...blank,...initial,occurrenceCount:initial?.occurrenceCount || 4});
  const set=(key,value)=>setForm(current=>({...current,[key]:value}));
  const submit=event=>{
    event.preventDefault();
    if (!form.name.trim() || !form.date) return;
    onSave({...form,id:form.id || `webinar-${Date.now()}`});
  };

  return <div className="modal-backdrop" onClick={onClose}>
    <form className="modal-card" onSubmit={submit} onClick={event=>event.stopPropagation()}>
      <div className="modal-heading">
        <div><h2>{isExisting ? 'ウェビナーシリーズを編集' : 'ウェビナーを作成'}</h2>
          <p>単発開催または定期開催を設定します。</p></div>
        <button type="button" className="icon-button" onClick={onClose}>
          <SafeIcon icon={FiIcons.FiX} />
        </button>
      </div>
      <label>ウェビナー名 *<input required value={form.name} onChange={event=>set('name',event.target.value)} /></label>
      <label>説明文<textarea rows="3" value={form.description} onChange={event=>set('description',event.target.value)} /></label>
      <div className="form-two">
        <label>シリーズ基準の開催日時 *<input required type="datetime-local" value={form.date} onChange={event=>set('date',event.target.value)} /></label>
        <label>登壇者<input value={form.speaker} onChange={event=>set('speaker',event.target.value)} /></label>
      </div>
      {isExisting && <p className="muted-copy">基準日時の変更は、既存の開催回には反映されません。個別開催回の日程は一覧から編集できます。</p>}
      <label>開催形式<select value={form.recurrence || 'single'} onChange={event=>set('recurrence',event.target.value)}>
        <option value="single">スポット開催（単発）</option><option value="weekly">毎週</option>
        <option value="biweekly">隔週</option><option value="monthly">毎月</option>
      </select></label>
      {form.recurrence!=='single' && <label>作成する開催回数（最大12回）
        <input type="number" min="1" max="12" value={form.occurrenceCount}
          onChange={event=>set('occurrenceCount',event.target.value)} />
      </label>}
      {isExisting && <p className="muted-copy">回数を増やすと開催回を追加します。既存開催回は削除されません。</p>}
      <label>参加URL<input type="url" value={form.url} onChange={event=>set('url',event.target.value)} placeholder="https://" /></label>
      <div className="form-two">
        <label>参加特典<input value={form.bonus} onChange={event=>set('bonus',event.target.value)} /></label>
        <label>初回の受付状態<select value={form.status} onChange={event=>set('status',event.target.value)}>
          <option>下書き</option><option>受付中</option>
        </select></label>
      </div>
      <label>申込受付終了<input type="datetime-local" value={form.deadline || ''}
        onChange={event=>set('deadline',event.target.value)} /></label>
      <label className="checkbox-line"><input type="checkbox" checked={form.reminders!==false}
        onChange={event=>set('reminders',event.target.checked)} />開催回ごとのメール予定を作成する（送信はしません）</label>
      <div className="modal-actions">
        <button type="button" className="secondary-button" onClick={onClose}>キャンセル</button>
        <button className="primary-button">保存して開催回を作成</button>
      </div>
    </form>
  </div>;
}

function SessionRow({session,registrations,onStatus,onDate,onCopy}) {
  const [date,setDate]=useState(session.date || '');
  const rows=registrations.filter(item=>item.sessionId===session.id);
  const attended=rows.filter(item=>item.attendance==='参加').length;
  const applicationPath=`/apply/${encodeURIComponent(session.id)}`;
  const url=new URL(applicationPath,location.origin).href;

  return <div className="session-row">
    <div className="session-main">
      <b>{new Date(session.date).toLocaleString('ja-JP',{timeZone:'Asia/Tokyo',year:'numeric',month:'long',day:'numeric',hour:'2-digit',minute:'2-digit'})}</b>
      <small>{rows.length}申込 ・ {attended}参加</small>
    </div>
    <div className="session-controls">
      <input aria-label="開催日時" type="datetime-local" value={date} onChange={event=>setDate(event.target.value)} />
      <button className="secondary-button small" onClick={()=>onDate(session,date)}>日程保存</button>
      <select aria-label="開催回の状態" className="inline-select" value={session.status}
        onChange={event=>onStatus(session,event.target.value)}>
        <option>下書き</option><option>受付中</option><option>中止</option><option>開催済み</option>
      </select>
      <a className="secondary-button small session-url" href={applicationPath} target="_blank" rel="noreferrer">申込ページ</a>
      <button className="icon-button" title="申込URLをコピー" onClick={()=>onCopy(url)}>
        <SafeIcon icon={FiIcons.FiCopy} />
      </button>
    </div>
  </div>;
}

export default function Webinars({webinars,setWebinars,sessions,setSessions,registrations,setDeliveries,logs,setLogs}) {
  const [modal,setModal]=useState(null);

  const createOrUpdate=webinar=>{
    const exists=webinars.some(item=>item.id===webinar.id);
    setWebinars(list=>exists ? list.map(item=>item.id===webinar.id ? webinar : item) : [webinar,...list]);
    const generated=buildSessions(webinar,webinar.occurrenceCount);
    setSessions(list=>{
      const existingIds=new Set(list.map(item=>item.id));
      return [...generated.filter(item=>!existingIds.has(item.id)),...list];
    });
    setLogs(list=>appendLog(list,exists ? 'ウェビナー編集' : 'ウェビナー作成',
      `${webinar.name} / ${exists ? 'シリーズ情報を更新・新規回のみ追加' : '開催回を作成'}`));
    setModal(null);
  };

  const duplicate=webinar=>{
    setModal({
      ...webinar,id:`webinar-${Date.now()}`,name:`${webinar.name}（複製）`,
      status:'下書き',date:'',recurrence:'single',occurrenceCount:1
    });
  };

  const changeDate=(session,date)=>{
    if (!date) return;
    const next=sessions.map(item=>item.id===session.id
      ? {...item,date,dateOverridden:true} : item);
    setSessions(next);
    setDeliveries(list=>rescheduleSessionDeliveries(session.id,next,registrations,list));
    setLogs(list=>appendLog(list,'開催回の日程変更',`${session.id} / 未送信メール予定を再計算`));
  };

  const changeStatus=(session,status)=>{
    setSessions(list=>list.map(item=>item.id===session.id ? {...item,status} : item));
    setLogs(list=>appendLog(list,status==='中止' ? '開催回中止' : '開催回公開状態変更',
      `${session.id}: ${status}`));
  };

  const changeAllStatus=(webinar,status)=>{
    const ids=new Set(sessions.filter(item=>item.webinarId===webinar.id).map(item=>item.id));
    setSessions(list=>list.map(item=>ids.has(item.id) ? {...item,status} : item));
    setLogs(list=>appendLog(list,status==='中止' ? 'シリーズ全開催回を中止' : 'シリーズ全開催回を公開',
      `${webinar.name}: ${ids.size}開催回を${status}に変更`));
  };

  const copyUrl=async url=>{
    try {
      await navigator.clipboard.writeText(url);
      window.alert('この開催回の申込URLをコピーしました。');
    } catch {
      window.prompt('申込URLをコピーしてください',url);
    }
  };

  return <div className="page-stack">
    <PageTitle title="ウェビナー管理" subtitle="定期シリーズと個別の開催回を分けて管理します。"
      action={<button className="primary-button" onClick={()=>setModal({})}>
        <SafeIcon icon={FiIcons.FiPlus} />新規作成</button>} />
    <div className="notice-banner"><SafeIcon icon={FiIcons.FiInfo} />
      <span>申込URL・申込数・開催状態は開催回ごとに管理します。メール予定は記録のみで、外部配信サービス未接続のため送信されません。</span>
    </div>
    <div className="webinar-grid">
      {webinars.map(webinar=>{
        const occurrences=sessions.filter(session=>session.webinarId===webinar.id);
        const cadence={single:'スポット開催',weekly:'毎週',biweekly:'隔週',monthly:'毎月'}[webinar.recurrence || 'single'];
        const isExisting=modal?.id===webinar.id;
        return <Card className="webinar-card" key={webinar.id}>
          <div className="webinar-card-top">
            <span className="webinar-symbol"><SafeIcon icon={FiIcons.FiVideo} /></span>
            <Status tone="neutral">{cadence}</Status>
            <button className="icon-button" title="開催回を複製" onClick={()=>duplicate(webinar)}>
              <SafeIcon icon={FiIcons.FiCopy} />
            </button>
          </div>
          <h3>{webinar.name}</h3><p>{webinar.description || '説明はまだ登録されていません。'}</p>
          <div className="webinar-meta">
            <span><SafeIcon icon={FiIcons.FiUser} />{webinar.speaker || '登壇者未設定'}</span>
            <span><SafeIcon icon={FiIcons.FiGift} />{webinar.bonus || '参加特典未設定'}</span>
          </div>
          <div className="session-list">
            <div className="session-heading">
              <b>開催回（{occurrences.length}）</b>
              <button className="text-button" onClick={()=>setModal(webinar)}>シリーズを編集</button>
            </div>
            <div className="session-controls">
              <button className="secondary-button small" onClick={()=>changeAllStatus(webinar,'受付中')}>全回を公開</button>
              <button className="danger-button small" onClick={()=>changeAllStatus(webinar,'中止')}>全回を中止</button>
            </div>
            {occurrences.map(session=><SessionRow key={session.id} session={session}
              registrations={registrations} onStatus={changeStatus} onDate={changeDate} onCopy={copyUrl} />)}
            {!occurrences.length && <p className="muted-copy">開催回がありません。</p>}
          </div>
          {modal && <span className="visually-hidden" />}
        </Card>;
      })}
      {!webinars.length && <Card><p className="muted-copy">ウェビナーがありません。新規作成から追加してください。</p></Card>}
    </div>
    {modal && <WebinarForm initial={modal.id ? modal : null}
      isExisting={webinars.some(item=>item.id===modal.id)}
      onSave={createOrUpdate} onClose={()=>setModal(null)} />}
  </div>;
}
